import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../../../../layout/theme/utils/colors';

export default makeStyles((theme: Theme) =>
  createStyles({
    boxContainer: {
      display: 'flex',
    },
    textField: {
      marginRight: theme.spacing(2),
    },
    cancelButton: {
      height: 30,
      marginRight: theme.spacing(1),
      border: `1px solid ${Colors.navy}`,
      backgroundColor: 'transparent',
      color: Colors.navy,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    saveButton: {
      height: 30,
    },
    replacingBox: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    replacingText: {
      color: Colors.font_gray,
    },
    arrowIcon: {
      color: Colors.font_gray,
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
  }),
);
